import { Outlet } from 'react-router'
import { ErrorBox } from '@/components/commons/error-box'
import { AlertTriangleIcon } from '@/components/ui/icons'
import { ErrorBoundary } from '@/error-boundary'
import { OpsVettingURLParams } from '@/features/ops-vetting/types'
import { useURLParsedParams } from '@/hooks/use-url-parsed-params'
import { OpsVettingDataInitializer } from '@/pages/experience-vetting'
import { useTranslation } from '@/translations/i18n'

export const ExperienceProPhotosRoute = () => {
	const { t } = useTranslation()
	const urlParams = useURLParsedParams(OpsVettingURLParams)

	return urlParams.success ? (
		<OpsVettingDataInitializer experienceId={urlParams.data.id}>
			<ErrorBoundary>
				<Outlet context={{ urlParams: urlParams.data }} />
			</ErrorBoundary>
		</OpsVettingDataInitializer>
	) : (
		<ErrorBox
			icon={<AlertTriangleIcon />}
			title={t('errors:invalid_url')}
		/>
	)
}
ExperienceProPhotosRoute.displayName = 'ExperienceProPhotosRoute'
